import { render } from "./slot.vue?vue&type=template&id=0b069240&scoped=true"
import script from "./slot.vue?vue&type=script&lang=js"
export * from "./slot.vue?vue&type=script&lang=js"

import "./slot.vue?vue&type=style&index=0&id=0b069240&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b069240"]])

export default __exports__